import { Injectable } from '@angular/core';
import { ClassType } from './class-type.model';
import { IClassTypeService } from './iclass-type.service';
import { ApiService } from '../../../shared/api/api.service';
import { PagedResultGeneric } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class ClassTypeService implements IClassTypeService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  getClassType = (id: number): Promise<ClassType> => {
    let url: string = '/classtype/' + id;
    return this._apiService.get(url);
  };

  getClassTypes(searchParams: any, forceRefresh?: boolean): Promise<PagedResultGeneric<ClassType>> {
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    let url: string = '/classtypes';
    return this._apiService.getPaged(url, searchParams, cacheOptions);
  }

  public updateClassType = (classType: ClassType): Promise<number> => {
    let url = '/ClassType/' + classType.ClassTypeId;
    return this._apiService.put(url, classType);
  };

  public createClassType = (classType: ClassType): Promise<number> => {
    let url = '/ClassTypes';
    return this._apiService.post(url, classType);
  };

  public deleteClassType = (id: number): Promise<void> => {
    let url: string = '';

    url = '/ClassType/' + id;
    return this._apiService.delete(url).then((): Promise<void> => {
      return Promise.resolve();
    });
  };
}
